import React from "react"
import useId from "../hooks/useId"

const TPHLogo: React.FC = (props) => {
  const id = useId()

  return (
    <svg fill="none" viewBox="0 0 473 573" {...props}>
      <path
        fill={`url(#logo_gradient-${id})`}
        d="M.9 46.76c60.76.25 121.5 1.8 182.26 1.22 44.73-.43 89.03 21.05 116.19 56.6 22.74 28.63 33.14 65.93 31 102.24 1.96 63.88-43.05 125.73-104.83 142.8-18.36 5.67-37.66 5.85-56.7 6.5-12.38.07-23.4 9.97-24.33 22.34-1.9 28.84 0 57.83-.93 86.7-3.27 43.2-32.86 82.86-73.1 98.76-22.1 9.65-46.57 9.04-70.17 8.68C.07 542.29.6 512 0 481.73c15.35-1.82 34.15 2.44 45.74-10.58 9.68-10.36 5.6-25.36 6.85-38.06 2.54-28.94-3.41-59.11 7.17-86.95A131.4 131.4 0 0179.5 310.3c-14.35-19.65-24.07-43.04-25.11-67.54-.72-26.26-.79-52.52-2.48-78.74-.35-12.09-10.5-23.17-22.6-24.29-9.64-1.18-19.37-.93-29.01-1.32.35-30.57-.87-61.16.6-91.65zm143.01 98.93c1.22 28.7 2.66 57.47.72 86.16-1.61 16.93 10.51 33.22 27.01 37.02 32.1 8.8 66.4-15.92 72.75-47.63 7.9-32.36-16-67.59-48.43-73.72-15.65-2.75-31.6-1.62-48.52-1.76l-3.52-.07z"
      />
      <path
        fill="#EEF2F5"
        d="M372.19 0a100.5 100.5 0 110 201h-61.7a38.81 38.81 0 01-38.8-38.8v-61.7A100.5 100.5 0 01372.19 0z"
      />
      <path
        fill="#141414"
        d="M355.55 111.97h-49.61a9.2 9.2 0 000 18.4h49.61a9.2 9.2 0 000-18.4zm26.96 33.28h-76.57a9.2 9.2 0 000 18.4h76.57a9.2 9.2 0 000-18.4z"
      />
      <defs>
        <linearGradient
          id={`logo_gradient-${id}`}
          x1="250.28"
          x2="-161.47"
          y1="79.37"
          y2="376.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9423FC" />
          <stop offset=".51" stopColor="#FF70A5" />
          <stop offset="1" stopColor="#FEAF6D" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default TPHLogo
